import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {AlertListService, QueryStringService} from "@xref/ngx";
import * as Cookies from "js-cookie";
import {TAndCReturnData} from "src/app/components/t-and-c-request-box/t-and-c-request-box.component";

import {environment} from "../../../../../environments/environment";
import Constants from "../../../../shared/constants";
import constants from "../../../../shared/constants";
import {
    DeprecatedLoginResponse,
    DeprecatedLoginResponseData,
    IdService,
    LoginResponse
} from "../../../../services/id/id.service";
import {PermissionsService} from "../../../../services/permissions/permissions.service";

@Component({
    selector: "xlog-saml-sso",
    templateUrl: "./saml-sso.component.pug",
    styleUrls: ["./saml-sso.component.scss"],
    standalone: false
})
export class SamlSsoComponent implements OnInit {
    request_id: string;
    region: any;
    platform: string;
    errorMessage: string;
    showTAndC: Boolean = false;
    tAndCData: TAndCReturnData;
    t_and_c_url: string;

    constructor(
        private qString: QueryStringService,
        private id: IdService,
        private alertList: AlertListService,
        private router: Router,
        private featureFlagService: PermissionsService,
    ) {}

    ngOnInit() {
        this.id.ent_9105 = this.featureFlagService.isFeatureActivated('ENT-9105-PENETRATION-TEST-2025');
        this.errorMessage = decodeURIComponent(
            this.qString.getParam("error_message")
        );
        this.request_id = decodeURIComponent(this.qString.getParam("request_id"));
        this.platform = decodeURIComponent(this.qString.getParam("platform"));
        this.tAndCData = new TAndCReturnData({request_id: this.request_id, terms: false});
        this.region = Cookies.get(Constants.API_REGION_TOKEN);

        // Clear UUID cookie
        Cookies.remove(Constants.SSO_UUID, { domain: environment.DOMAIN });
        Cookies.remove(Constants.SSO_REDIRECT_URL, { domain: environment.DOMAIN });

        if (this.errorMessage && this.errorMessage != 'undefined' && this.errorMessage != 'null') {
            if (this.errorMessage == constants.GET_T_AND_C) {
                this.showTAndC = true;
            } else {
                this.showError();
            }
            return;
        }

        if (this.platform === 'xsp') {
            this.t_and_c_url = constants.T_AND_C_OMNI;
        } else {
            this.t_and_c_url = constants.T_AND_C_CLASSIC;
        }
        this.login();
    }

    login() {
        const orgId = Cookies.get(Constants.ORG_UID);
        if (this.request_id && this.request_id != "undefined" && this.request_id != "null") {
            const success = this.id.ent_9105 ? (res: LoginResponse) => {
                // Reset
                this.id.removeToken();
                this.id.setTokens(res.data);
                this.id.redirectToReturnUrl();
            } : (res: DeprecatedLoginResponse) => {
                // Reset
                this.id.removeToken();
                this.id.deprecatedSetTokens(res.data);
                this.id.DeprecatedRedirectToReturnUrl();
            };

            const error = (res: any) => {
                if (res.error.message == constants.GET_T_AND_C) {
                    this.showTAndC = true;
                } else {
                    this.showError();
                }
            };
            if (this.tAndCData != undefined) {
                this.id.authenticateSaml(this.tAndCData.request_id, orgId, this.tAndCData.terms).subscribe(success, error);
            } else {
                this.id.authenticateSaml(this.request_id, orgId, false).subscribe(success, error);
            }
        } else {
            this.showError();
        }

    }

    showError() {
        this.alertList.append([
            {
                keepOnRouteChange: true,
                active: true,
                type: "danger",
                messageKey: "alerts.sso.userNotCredentialed",
            },
        ]);
        this.router.navigate(["/"]);
    }

    tAndCAccepted(data: TAndCReturnData) {
        this.showTAndC = false;
        this.tAndCData = data;
        this.login();
    }
}
